import { axiosRequest } from "../axios.config";

const categoryApi = {
  getAllCategories: async () => {
    const url = "Category";
    const response = await axiosRequest.get(url);
    return response;
  },
  getTopCategories: async () => {
    const url = "Category/Get-sub-category";
    const response = await axiosRequest.get(url, {
      params: { PageNumber: 1, PageSize: 10 },
    });
    return response;
  },
  createCategory: async ({ name, parentId }) => {
    const url = "Category";
    const response = await axiosRequest.post(url, { name, parentId });
    return response;
  },
  updateCategory: async ({ categoryId, name, parentId }) => {
    const url = "Category";
    const response = await axiosRequest.put(
      url,
      { name, parentId },
      { params: { categoryId } }
    );
    return response;
  },
  deleteCategory: async ({ categoryId }) => {
    const url = "Category";
    const response = await axiosRequest.put(url, null, {
      params: { categoryId },
    });
    return response;
  },
};

export { categoryApi };
